import {createRouter, createWebHistory} from 'vue-router';
import CabinetLayout from "@/layouts/CabinetLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import i18n from "@/plugins/i18n";

/**
 * Без входа открыта только страница входа (ЭЦП / eGov Mobile). Документ смотрит и подписывает
 * только вошедший участник — раньше карточку, файлы и подпись открывала одна ссылка с GUID.
 */
const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            name: 'login',
            path: '/',
            component: () => import('/src/pages/auth/TheLogin/TheLogin.vue'),
            meta: {public: true, layout: AuthLayout, title: 'page.login'},
        },
        // Старые ссылки (письма, QR на печатных копиях) — в карточку кабинета.
        {path: '/login', redirect: {name: 'login'}},
        {path: '/documents/:guid', redirect: (to) => ({name: 'cabinet-documents-item', params: {guid: to.params.guid}})},
        {path: '/documents/preview/:guid', redirect: (to) => ({name: 'cabinet-documents-item', params: {guid: to.params.guid}})},
        {
            name: 'cabinet',
            path: '/cabinet',
            meta: {layout: CabinetLayout},
            redirect: {name: 'in-work'},
            children: [
                {
                    name: 'in-work',
                    path: 'in-work',
                    component: () => import('/src/pages/cabinet/pages/InWorkPage.vue'),
                    meta: {title: 'sidebar.in_work'},
                },
                {
                    name: 'reviewer-list',
                    path: 'reviewer-list',
                    component: () => import('/src/pages/cabinet/pages/ReviewerListPage.vue'),
                    meta: {title: 'sidebar.reviewers'},
                },
                {
                    name: 'reviewed-documents',
                    path: 'reviewer-documents',
                    component: () => import('/src/pages/cabinet/pages/ReviewedDocumentsPage.vue'),
                    meta: {title: 'sidebar.reviewed'},
                },
                {
                    name: 'cabinet-documents-item',
                    path: 'documents/:guid',
                    component: () => import('/src/pages/cabinet/pages/DocumentItem.vue'),
                    meta: {title: 'page.document'},
                    props: (route) => ({
                        ...route.params
                    }),
                }
            ]
        },
        {path: '/:pathMatch(.*)*', redirect: {name: 'login'}},
    ]
});

router.beforeEach((to) => {
    const hasToken = !!localStorage.getItem('token');
    // Вошедшему страница входа не нужна — сразу в кабинет.
    if (to.name === 'login' && hasToken) {
        return {name: 'in-work'};
    }
    if (to.meta.public || hasToken) {
        return true;
    }
    return {name: 'login', query: {redirect: to.fullPath}};
});

// Заголовок вкладки браузера: раздел и «Novator» — как у системы.
router.afterEach((to) => {
    const {t} = i18n.global;
    document.title = to.meta.title ? `${t(to.meta.title)} — Novator` : t('app.name');
});

export default router;
